import React from 'react';
import { useParams, useNavigate } from '@tanstack/react-router';
import { Page } from '@chatsdet/ui';
import { PropertiesView } from './Properties';
import { Attachments } from './Attachments';
import { SeedDataCatalog } from './SeedDataCatalog';
import { useBreadcrumbs } from '../../contexts/BreadcrumbsContext';
import { useSubNav } from '../../hooks/useSubNav';
import { buildTestDataNavConfig } from './TestDataLayout';

type TestDataSection = 'properties' | 'attachments' | 'seed-data';

const sectionLabels: Record<TestDataSection, string> = {
  properties: 'Applications',
  attachments: 'Attachments',
  'seed-data': 'Seed Data',
};

export function TestDataPage() {
  const params = useParams({ strict: false }) as { section?: string };
  const navigate = useNavigate();
  const section = (params.section as TestDataSection) || 'properties';

  const navConfig = React.useMemo(() => buildTestDataNavConfig(), []);
  useSubNav(navConfig);

  const breadcrumbs = React.useMemo(
    () => [
      { label: 'Home', onPress: () => navigate({ to: '/' }) },
      { label: 'Test Data', onPress: () => navigate({ to: '/test-data' }) },
      ...(section !== 'properties'
        ? [{ label: sectionLabels[section] }]
        : []),
    ],
    [section, navigate]
  );
  useBreadcrumbs(breadcrumbs);

  switch (section) {
    case 'attachments':
      return (
        <Page>
          <Attachments showBreadcrumbs={false} />
        </Page>
      );
    case 'seed-data':
      return (
        <Page>
          <SeedDataCatalog />
        </Page>
      );
    case 'properties':
    default:
      return (
        <Page>
          <PropertiesView layout="embedded" showBreadcrumbs={false} />
        </Page>
      );
  }
}
